export const getOptionsFromEnumAndMap = <
  Tenum extends string,
  TLabelMap extends Map<Tenum, string>
>(
  enumType: Tenum[],
  labelMap: TLabelMap
): Record<string, string> => {
  return enumType.reduce(
    (prevValue, currentValue) => ({
      ...prevValue,
      [currentValue]: labelMap.get(currentValue) ?? currentValue
    }),
    {}
  );
};

export const getOptionsFromEnumAndRecord = <
  Tenum extends string,
  TRecord extends Record<Tenum, string>
>(
  enumType: Tenum[],
  labelRecord: TRecord
): Record<string, string> => {
  return enumType.reduce(
    (prevValue, currentValue) => ({
      ...prevValue,
      [currentValue]: labelRecord[currentValue] ?? currentValue
    }),
    {}
  );
};
